// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qf-2";
export var chatLink = "_qf-0";
export var chatText = "_qf-1";